import React from 'react'
import moment from 'moment'
import Helmet from 'react-helmet'

const MarkdownWrapper = ({ route }) => {
  const post = route.page.data

  let postInfo = null
  if (post.type !== 404) {
    postInfo = (
      <em style={{ display: 'block' }}>
          Posted {moment(post.date).format('MMMM D, YYYY')}
      </em>
    )
  }

  return (
    <div className="markdown">
      <Helmet
        title={post.title}
      />
      <section id="main">
        <h1 style={{ marginTop: 0 }}>{post.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: post.body }} />
      </section>
      {postInfo}
    </div>
  )
}

MarkdownWrapper.propTypes = {
  route: React.PropTypes.object,
}

export default MarkdownWrapper



// WEBPACK FOOTER //
// ../wrappers/md.jsx